(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
  var drawer   = document.getElementById('cart-drawer');
  if (!drawer) return;

  var backdrop = drawer.querySelector('.cd__backdrop');
  var closeBtn = document.getElementById('cd-close');
  var loading  = document.getElementById('cd-loading');
  var itemsEl  = document.getElementById('cd-items');
  var recsEl   = document.getElementById('cd-recs');
  var emptyEl  = document.getElementById('cd-empty');
  var footerEl = document.getElementById('cd-footer');
  var titleCountEl = document.getElementById('cd-title-count');
  var totalEl  = document.getElementById('cd-total');
  var shipLabelEl = document.getElementById('cd-shipping-label');
  var subtotalRowEl = document.getElementById('cd-summary-subtotal');
  var subtotalEl = document.getElementById('cd-subtotal');
  var discountRowEl = document.getElementById('cd-summary-discount');
  var discountLineEl = document.getElementById('cd-discount-line');
  var discountChipEl = document.getElementById('cd-discount-chip');
  var discountChipCode = discountChipEl ? (discountChipEl.dataset.code || 'VINTAGE80') : 'VINTAGE80';
  var discountLabelEl = document.getElementById('cd-discount-label');
  var checkoutNoteEl = document.getElementById('cd-checkout-note');
  var vintageAttemptSig = null;
  var checkoutFormEl = document.getElementById('cd-checkout-form');
  var lastCart = null;

  if (checkoutFormEl) {
    checkoutFormEl.addEventListener('submit', function (e) {
      // Figure out the discount code the cart SHOULD carry into checkout:
      // Vintage80 when there's a Vintage item in the cart.
      var cartHasVintage = (lastCart && lastCart.items || []).some(function (it) {
        return String(it.product_title || it.title || '').toLowerCase().indexOf('vintage') !== -1;
      });
      var vintageEnabled = discountChipEl && discountChipEl.dataset.enabled === 'true';
      var wantVintage = !!(vintageEnabled && cartHasVintage);
      var wantedCodes = [];
      if (wantVintage) wantedCodes.push(discountChipCode);

      // Only rebuild the cart when what's actually applied doesn't match what's
      // wanted (a stale code, a missing code, or Vintage80 hasn't landed yet).
      // A cart that's already in the correct state submits normally and is
      // left untouched, so a legitimately-applied discount is never at risk
      // of being lost to a failed rebuild step.
      var cartDiscountCodes = (lastCart && lastCart.discount_codes) || [];
      var appliedCodes = cartDiscountCodes.filter(function (d) { return d.applicable; })
        .map(function (d) { return String(d.code).toUpperCase(); });
      var hasStaleDiscount = cartDiscountCodes.some(function (d) {
        return d.code && wantedCodes.indexOf(String(d.code).toUpperCase()) === -1;
      });
      var missingWanted = wantedCodes.some(function (code) { return appliedCodes.indexOf(code) === -1; });
      if (!hasStaleDiscount && !missingWanted) {
        return; // cart already carries exactly the discounts it should — submit normally
      }

      // Something needs fixing before checkout. Just updating the cart's
      // discount value isn't always enough — Shopify can resume a
      // previously-created checkout session (from an earlier abandoned
      // checkout) that still has an old discount baked in, independent of
      // what the cart currently shows. Force a genuinely fresh checkout by
      // clearing the cart and re-adding the same line items (this invalidates
      // any stale checkout draft tied to the old cart state), then submit.
      var items = (lastCart && lastCart.items) ? lastCart.items.map(function (it) {
        var line = { id: it.variant_id, quantity: it.quantity };
        var hasProps = false;
        for (var k in (it.properties || {})) {
          if (it.properties[k] !== null && it.properties[k] !== '') { hasProps = true; break; }
        }
        if (hasProps) line.properties = it.properties;
        return line;
      }) : [];
      if (!items.length) return; // nothing to rebuild — let it submit normally

      e.preventDefault();
      // NOTE: checkoutFormEl.submit() (the JS method) would NOT carry the
      // "checkout" button's name/value pair — that's only sent by a real
      // click-triggered submit — so Shopify's /cart endpoint would just land
      // back on /cart instead of redirecting to checkout. Navigate to
      // /checkout directly instead.
      // Explicitly strip any discount sitting on the cart first (clearing +
      // re-adding items alone isn't always enough — Shopify can still resume
      // a previously-created checkout session with the old discount baked in).
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: '' })
      })
        .catch(function () {})
        .then(function () {
          return fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } });
        })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          });
        })
        .then(function () {
          if (!wantedCodes.length) return null;
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: wantedCodes.join(',') })
          });
        })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function () { window.location.href = '/checkout'; });
    });
  }

  /* ── Recs only show once the cart has an item from the Cart
     Recommendations collection (Theme Settings). ── */
  var recHandlesEl = document.getElementById('cd-rec-handles');
  var recHandles = [];
  if (recHandlesEl) {
    try { recHandles = JSON.parse(recHandlesEl.textContent) || []; } catch (e) {}
  }
  function cartHasRecCollectionItem(cart) {
    if (!recHandles.length) return false;
    return cart.items.some(function (item) { return recHandles.indexOf(item.handle) !== -1; });
  }

  function formatMoney(cents) {
     return '$' + (cents / 100).toFixed(2);
  }
  function formatMoneyComma(cents, dropZeroCents) {
    var digits = (dropZeroCents && cents % 100 === 0) ? 0 : 2;
    return '$' + (cents / 100).toLocaleString('en-AU', { minimumFractionDigits: digits, maximumFractionDigits: digits });
  }

  /* ── Item-price compare-at: fetches each line's product JSON to find
     the variant's compare_at_price, so a discounted line item can show
     its original (crossed-out) price beside the sale price. ── */
  var productJsonCache = {};
  function getProductJson(handle) {
    if (productJsonCache[handle]) return productJsonCache[handle];
    productJsonCache[handle] = fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return productJsonCache[handle];
  }
  function updateItemPriceCompares(cart) {
    if (!itemsEl) return;
    var handles = cart.items
      .map(function (item) { return item.handle; })
      .filter(function (h, i, arr) { return h && arr.indexOf(h) === i; });
    Promise.all(handles.map(getProductJson)).then(function (products) {
      var byHandle = {};
      handles.forEach(function (h, i) { byHandle[h] = products[i]; });
      if (cart !== lastCart) return; // a newer cart render has taken over
      var bfSaveTotal = 0;
      cart.items.forEach(function (item) {
        var p = byHandle[item.handle];
        var variant = p && p.variants && p.variants.filter(function (v) { return v.id === item.variant_id; })[0];
        var cmp = variant && variant.compare_at_price ? parseInt(variant.compare_at_price, 10) : 0;
        if (cmp <= item.price) return;
        var priceEl = itemsEl.querySelector('[data-key="' + item.key + '"] .cd__item-price');
        if (!priceEl) return;
        var cmpLine = cmp * item.quantity;
        var saveAmt = cmpLine - item.original_line_price;
        bfSaveTotal += saveAmt;
        priceEl.classList.add('cd__item-price--sale');
        priceEl.innerHTML = '<span class="cd__item-price-now">' + formatMoneyComma(item.original_line_price) + '</span>'
          + '<s class="cd__item-price-compare">' + formatMoneyComma(cmpLine) + '</s>';
        var next = priceEl.nextElementSibling;
        if (!next || !next.classList.contains('cd__item-save')) {
          priceEl.insertAdjacentHTML('afterend', '<span class="cd__item-save">You save ' + formatMoneyComma(saveAmt, true) + '</span>');
        }
      });
      /* Summary: Subtotal at full (compare-at) price, then the compare-at
         savings plus any cart discount as one "Black Friday savings" row. */
      if (bfSaveTotal > 0) {
        var totalSave = bfSaveTotal + (cart.total_discount || 0);
        if (subtotalRowEl && subtotalEl) {
          subtotalRowEl.hidden = false;
          subtotalEl.textContent = formatMoney(cart.original_total_price + bfSaveTotal);
        }
        if (discountRowEl && discountLineEl) {
          discountRowEl.hidden = false;
          discountLineEl.textContent = '-' + formatMoney(totalSave);
        }
      }
    });
  }
  /* ── Shipping label: shows "Calculated at checkout" when at least one
     item in the cart is tagged PAID_SHIPPING_TAG (even if mixed with
     regular items) AND the cart total is $200 or under. Otherwise the
     whole cart shows "Free shipping". ── */
  var PAID_SHIPPING_TAG = 'paid-shipping';
  var FREE_SHIPPING_THRESHOLD_CENTS = 20000; // $200
  var productTagsCache  = {};

  function getProductTags(handle) {
    if (productTagsCache[handle]) return productTagsCache[handle];
    productTagsCache[handle] = fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { tags: [] }; })
      .then(function (p) { return p.tags || []; })
      .catch(function () { return []; });
    return productTagsCache[handle];
  }

  function updateShippingLabel(cart) {
    if (!shipLabelEl) return;
    if (!cart.items.length) return;

    var handles = cart.items
      .map(function (item) { return item.handle; })
      .filter(function (h, i, arr) { return h && arr.indexOf(h) === i; });

    Promise.all(handles.map(getProductTags)).then(function (tagLists) {
      var anyTagged = tagLists.some(function (tags) {
        return tags.indexOf(PAID_SHIPPING_TAG) !== -1;
      });
      var isPaid = anyTagged && cart.total_price <= FREE_SHIPPING_THRESHOLD_CENTS;
      shipLabelEl.textContent = isPaid ? 'Calculated at checkout' : 'Free shipping';
      shipLabelEl.classList.toggle('cd__free-ship--paid', isPaid);
    });
  }

  /* ── The Shopify chat widget lives inside a chain of shadow roots, so
     plain CSS selectors (even body:has(#shopify-chat)) can't reach it.
     Pierce the shadow tree to find the activator button, then hide its
     shadow host directly — same lookup used by the "Ask a question"
     buttons on the product pages. ── */
  function findChatHost(root) {
    if (!root) return null;
    var btn = root.querySelector('[part="activator"], .activator, [aria-label="Chat"]');
    if (btn) {
      var rootNode = btn.getRootNode();
      return (rootNode && rootNode.host) ? rootNode.host : null;
    }
    var els = root.querySelectorAll('*');
    for (var i = 0; i < els.length; i++) {
      if (els[i].shadowRoot) {
        var found = findChatHost(els[i].shadowRoot);
        if (found) return found;
      }
    }
    return null;
  }

  function setChatHidden(hidden) {
    var host = findChatHost(document);
    if (!host) return;
    if (hidden) host.style.setProperty('display', 'none', 'important');
    else host.style.removeProperty('display');
  }

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setChatHidden(true);
    refresh();
    setTimeout(function () { closeBtn && closeBtn.focus(); }, 440);
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setChatHidden(false);
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  /* Show a brief error notice inside the drawer */
  function showNotice(msg) {
    var existing = drawer.querySelector('.cd__notice');
    if (existing) existing.remove();
    var el = document.createElement('div');
    el.className = 'cd__notice';
    el.textContent = msg;
    var body = drawer.querySelector('.cd__body');
    if (body) body.insertAdjacentElement('afterbegin', el);
    setTimeout(function () { if (el.parentNode) el.remove(); }, 4000);
  }

  function sendUpdate(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function (r) {
      return r.json().then(function (data) { return { ok: r.ok, data: data }; });
    })
    .then(function (result) {
      if (!result.ok || !Array.isArray(result.data.items)) { refresh(); return; }
      renderCart(result.data);
    })
    .catch(function () { refresh(); });
  }

  function syncBadge(count) {
    document.querySelectorAll('.cart-count').forEach(function (b) {
      b.textContent = count;
      b.style.display = count > 0 ? '' : 'none';
    });
    var btn = document.querySelector('.cart-btn');
    if (btn) {
      btn.setAttribute('aria-label', count > 0 ? 'Cart (' + count + ' items)' : 'Cart');
    }
  }

  function renderCart(cart) {
    lastCart = cart;
    if (loading) loading.hidden = true;
    syncBadge(cart.item_count);
    if (titleCountEl) {
      titleCountEl.hidden = !cart.item_count;
      titleCountEl.textContent = cart.item_count;
    }
    var discountCents = cart.total_discount || 0;
    if (subtotalRowEl && subtotalEl) {
      subtotalRowEl.hidden = !(cart.item_count > 1 || discountCents > 0);
      subtotalEl.textContent = formatMoney(cart.original_total_price);
    }
    if (discountRowEl && discountLineEl) {
      discountRowEl.hidden = !(discountCents > 0);
      discountLineEl.textContent = discountCents > 0 ? ('-' + formatMoney(discountCents)) : '';
    }
    if (discountChipEl) {
      var vintageDiscount = (cart.discount_codes || []).filter(function (d) {
        return d.applicable && String(d.code).toUpperCase() === discountChipCode;
      })[0];
      var vintageCents = 0;
      if (vintageDiscount) {
        (cart.cart_level_discount_applications || []).forEach(function (app) {
          if (String(app.title || '').toUpperCase().indexOf(discountChipCode) !== -1) {
            vintageCents += app.total_allocated_amount || 0;
          }
        });
        if (!vintageCents) vintageCents = discountCents;
      }
      discountChipEl.hidden = !vintageDiscount;
      if (discountLabelEl) discountLabelEl.textContent = vintageDiscount ? ("You're getting an extra " + formatMoney(vintageCents) + ' off') : 'Discount unlocked';
      if (checkoutNoteEl) checkoutNoteEl.hidden = !vintageDiscount;

      /* ── Auto-apply VINTAGE80 to the cart (so it also carries through to
         checkout) whenever a Vintage-titled item is in the cart and the code
         isn't on it yet. Guarded by a per-cart-contents signature so it only
         fires once per unique set of line items, not on every render. ── */
      var vintageEnabled = discountChipEl.dataset.enabled === 'true';
      var cartHasVintage = (cart.items || []).some(function (item) {
        return String(item.product_title || item.title || '').toLowerCase().indexOf('vintage') !== -1;
      });
      var cartSig = (cart.items || []).map(function (item) { return item.key + ':' + item.quantity; }).join('|');
      if (vintageEnabled && cartHasVintage && !vintageDiscount && cartSig !== '' && cartSig !== vintageAttemptSig) {
        vintageAttemptSig = cartSig;
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: discountChipCode })
        })
        .then(function (r) { return r.json(); })
        .then(function (updatedCart) { renderCart(updatedCart); })
        .catch(function () {});
      }
    }
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));

    if (!cart.item_count) {
      if (itemsEl)  itemsEl.hidden  = true;
      if (recsEl)   recsEl.hidden   = true;
      if (footerEl) footerEl.hidden = true;
      if (emptyEl)  emptyEl.hidden  = false;
      return;
    }

    if (emptyEl)  emptyEl.hidden  = true;
    if (footerEl) footerEl.hidden = false;
    if (itemsEl)  itemsEl.hidden  = false;
    if (recsEl)   recsEl.hidden   = !cartHasRecCollectionItem(cart);

    if (totalEl) {
      totalEl.textContent = formatMoney(cart.total_price);
    }
    updateShippingLabel(cart);

    itemsEl.innerHTML = cart.items.map(function (item) {
      var itemUrl = item.url || '#';
      var imgInner = item.image
        ? '<img class="cd__item-thumb" src="' + item.image + '" alt="' + (item.title || '').replace(/"/g, '&quot;') + '" loading="lazy" width="96" height="96">'
        : '<div class="cd__item-thumb-placeholder"></div>';
      var imgHtml = '<a href="' + itemUrl + '" class="cd__item-thumb-link" aria-label="' + (item.product_title || '').replace(/"/g, '&quot;') + '">' + imgInner + '</a>';
      var removeBtnHtml = '<button class="cd__item-remove" aria-label="Remove item">'
        +   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
        +     '<path d="M4 7h16"/><path d="M9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2"/>'
        +     '<path d="M6 7l1 13a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-13"/>'
        +     '<path d="M10 11v6M14 11v6"/>'
        +   '</svg>'
        + '</button>';
      var props = item.properties || {};
      var sizeText = props._size || (item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '');
      var itemTitleLc = String(item.product_title || '').toLowerCase();
      var stockHtml = (itemTitleLc.indexOf('underlay') === -1 && itemTitleLc.indexOf('rug pad') === -1)
        ? '<span class="cd__item-stock">One of a kind<span class="cd__item-stock-sep" aria-hidden="true">&middot;</span>Only 1 available</span>'
        : '';
      var sizeChipHtml = sizeText
        ? '<span class="cd__item-size-chip"><i class="fa-solid fa-ruler" aria-hidden="true"></i>' + sizeText + '</span>'
        : '';
      return '<div class="cd__item" data-key="' + item.key + '">'
        + imgHtml
        + '<div class="cd__item-top">'
        +   '<a class="cd__item-name-link" href="' + itemUrl + '"><p class="cd__item-name">' + item.product_title + '</p></a>'
        +   removeBtnHtml
        + '</div>'
        + '<div class="cd__item-price-row">'
        +   '<span class="cd__item-price">' + formatMoney(item.original_line_price) + '</span>'
        +   stockHtml
        +   sizeChipHtml
        + '</div>'
        + '</div>';
    }).join('');
    updateItemPriceCompares(cart);
  }

  function refresh() {
    if (loading)  loading.hidden  = false;
    if (itemsEl)  itemsEl.hidden  = true;
    if (recsEl)   recsEl.hidden   = true;
    if (emptyEl)  emptyEl.hidden  = true;
    if (footerEl) footerEl.hidden = true;
    fetchCart().then(renderCart).catch(function () {
      if (loading) loading.hidden = true;
      if (emptyEl) emptyEl.hidden = false;
    });
  }

  /* ── Sync cart state in the background (not tied to opening the drawer), so
     Vintage80 is already applied/reflected before the shopper ever opens it.
     Runs once on load, and again whenever the page is restored from
     back/forward-cache (e.g. hitting Back from checkout), since bfcache resumes
     the exact previous DOM/script state without re-running anything. ── */
  function syncCartState() {
    fetchCart().then(renderCart).catch(function () {});
  }
  syncCartState();
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) syncCartState();
  });

  /* ── Delegated remove handler (survives innerHTML swaps) ── */
  itemsEl && itemsEl.addEventListener('click', function (e) {
    var remove = e.target.closest('.cd__item-remove');
    if (!remove) return;

    var item = e.target.closest('.cd__item');
    if (!item) return;

    item.style.opacity = '0.4';
    item.style.pointerEvents = 'none';
    sendUpdate(item.dataset.key, 0);
  });

  /* ── Rec: sync select → button variant id + price display ── */
  closeBtn && closeBtn.addEventListener('click', closeDrawer);

  /* Close when clicking outside the panel (on the dimmed backdrop area) */
  drawer.addEventListener('click', function (e) {
    if (!e.target.closest('.cd__panel')) closeDrawer();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cart-btn');
    if (!btn) return;
    e.preventDefault();
    openDrawer();
  });

  document.addEventListener('cart:item-added', function (e) {
    if (e.detail && e.detail.cart) renderCart(e.detail.cart);
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.cd__checkout-btn')) return;
    if (window.fbq) {
      fbq('track', 'InitiateCheckout', lastCart ? {
        value: lastCart.total_price / 100,
        currency: lastCart.currency,
        num_items: lastCart.item_count
      } : {});
    }
  });

  /* Silently sync on page load so a Vintage item already in the cart gets
     VINTAGE80 applied even if the drawer is never opened (e.g. landing
     straight on /cart or navigating to checkout). */
  fetchCart().then(renderCart).catch(function () {});

  window.CartDrawer = { open: openDrawer, close: closeDrawer, refresh: refresh };
})();
  } catch(e) { console.error(e); }
})();

})();
